import { Component, Input, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
// import { Title } from '@angular/platform-browser';
import { HomeService } from './shared';
import { UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { SliderModel, HOME_DATA } from './shared';
import { AuthenticationService, UtilityService, AdobeAnalyticsService, HttpClientService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { HeaderService } from './../header/header.service';
import { WelcomeService } from './../welcome/welcome.service';
import { MDMDetails } from './../../models/product';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { ADDP_PERMISSION_MAPPING, LOGIN_ERROR } from 'config';
import { HttpResponse } from '@angular/common/http';
import { Subject, Subscription, interval } from 'rxjs';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';
import {IndexedDbService} from '../../indexed-db.service';
import { takeUntil, distinctUntilChanged, filter, timeout, take } from 'rxjs/operators';

declare var ENV_VAR;
declare var PREMIER_LOGIN_URL: any;
declare var MYATT_LOGIN_URL: any;
declare var FIRSTNET_LOCAL_CONTROL_URL: any;
declare var ENV_PORTAL: any;
@Component({
  selector: 'app-home',
  providers: [HomeService, WelcomeService, AdobeAnalyticsService, IndexedDbService],
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  user: UserProfileModel;
  tagUrl: any;
  public pageNumber = 0;
  public pageCount = 0;
  public enableArrowKeys = true;
  public transitionDuration = 2000;
  public transitionInterval = 8000;
  public signUp: boolean;
  mdmDetails: MDMDetails;
  homePage: any;
  slider: SliderModel[];
  loginFlag: boolean;
  signUpStatus: any;
  landingPageRoute: string;
  breadCrumbs: BreadCrumbModel[];
  firstNetFlag: boolean = (ENV_PORTAL === 'fnabc') ? true : false;
  pageSlider: any;
  environment: boolean = (ENV_VAR !== 'prod') ? true : false;
  pageLoadChangesDone: boolean = false;
  showArrows = 'hidden';
  loginErrorMessage: string;
  redirectFlag: boolean = false;
  sendActiveCount = 0;
  lastLoginTime: any;
  // private titleService: Title
  public openTiles1: boolean = true;
  public closeTiles1: boolean = false;
  public openTiles2: boolean = true;
  public closeTiles2: boolean = false;
  public openTiles3: boolean = true;
  public closeTiles3: boolean = false;
  public openTiles4: boolean = true;
  public closeTiles4: boolean = false;
  public showP: boolean = false;
  public hideShortDesc1: boolean = true;
  public hideShortDesc2: boolean = true;
  public hideShortDesc3: boolean = true;
  public hideShortDesc4: boolean = true;
  public hideLearnMore1: boolean = false;
  public hideLearnMore2: boolean = false;
  public hideLearnMore3: boolean = false;
  public hideLearnMore4: boolean = false;
  public openLearnPage: boolean = false;
  public show5gTile: boolean = true;
  showProfileErrorModal: boolean = false;
  stubIdErrorMsg: any;
  errorHeader: string;
  fanInlibleStatus: boolean = false;
  private iconsPollSub: Subscription;
  private destroy$ = new Subject<void>();
  // @Input() aClickedEvent: string;
  public enrollStatusSubscription: Subscription;
  fansInEligibleErrorMsg1: string = "Right now, there are no FANs availble for you to register in the Device Management Program.";
  fansInEligibleErrorMsg2: string = "This is usually because: The FAN doesn't meet eligibility requirements.";
  fansInEligibleErrorMsg3: string = "If you believe this is incorrect, contact your company administrator or AT&T representative for your help.";

  clickEventsubscription: Subscription;
  constructor(private route: ActivatedRoute, private router: Router, private authenticationService: AuthenticationService,
    private homeService: HomeService, private utilityService: UtilityService, private adobeAnalyticsService: AdobeAnalyticsService,
    private breadCrumbService: BreadCrumbService, private chips: ChipsService, private headerService: HeaderService, private pageloaderService: PageLoaderService, private dbService: IndexedDbService) {
    this.user = new UserProfileModel();
    this.homePage = HOME_DATA;
    this.loginFlag = false;
    this.mdmDetails = new MDMDetails();

    //get cookie if unauthenticated user clicked on enroll
    let isEnrollClicked = this.authenticationService.getCookie('enroll');
    let isLearnClicked = this.authenticationService.getCookie('productselection');
    if(isEnrollClicked || isLearnClicked){
      let d = new Date();
      d.setTime(d.getTime());
      let expires = "expires=" + d.toUTCString();
      document.cookie = "enroll=true; " + expires + "; domain=.att.com; path=/";
      document.cookie = "productselection=true; " + expires + "; domain=.att.com; path=/";
      this.headerService.sendEnrollClickEvent(true);
    }
    

    // if(localStorage.getItem("navigateFrom") && localStorage.getItem("navigateFrom") == "enroll"){
    //   localStorage.removeItem("navigateFrom");
    //   this.headerService.sendEnrollClickEvent(true);
    // }
// //2024 vulnerabilities- missing secure keyword in cookie
// let missingCookies = [
// {cookieName:"aacState", domain:".att.com"},
// {cookieName:"_4c_", domain:".att.com"},
// {cookieName:"_uetsid", domain:".att.com"}, 
// {cookieName: "_gcl_au", domain:".att.com"}, 
// {cookieName: "mbox", domain:".att.com"}, 
// {cookieName:"_uetvid", domain:".att.com"}, 
// {cookieName:"_cs_mk", domain:".att.com"}, 
// {cookieName:"s_cc", domain:".att.com"}, 
// {cookieName:"at_check", domain:".att.com"}, 
// {cookieName: "PIM-SESSION-ID", domain:".att.com"}, 
// {cookieName:"fabrickId", domain:"test-dmp.wireless.att.com"}, 
// {cookieName:"e1Segment", domain:"test-dmp.wireless.att.com"}, 
// {cookieName:"bSegment", domain:"test-dmp.wireless.att.com"},
// {cookieName:"tr264", domain:".att.com"},
// {cookieName: "ORA_FPC", domain:".att.com"},
// {cookieName: "mboxEdgeCluster", domain: ".att.com"},
// {cookieName: "dlomInfo", domain: ".att.com"},
// {cookieName: "bAuthNState", domain: ".att.com"},
// {cookieName: "dlomInfoB", domain: ".att.com"}
// // {cookieName: "targetURL", domain: ".att.com"}
// ];

// missingCookies.forEach((el)=> {
//   document.cookie = el.cookieName+"=;expires="+new Date(0).toUTCString()+";domain="+el.domain+";path=/";
// })

    
//     const promise = new Promise((resolve, reject) => {
//       let missingData = missingCookies.map((elm) => {
//         if(splittedCookies.findIndex(el => el.indexOf(elm.cookieName)!= -1) != -1){
//            elm.cookieName = splittedCookies[splittedCookies.findIndex(el => el.indexOf(elm.cookieName)!= -1)];
//         }
//         return elm;
//       });
//       resolve(missingCookies);
//     }).then(result => {
//       // Handle successful result
//       missingCookies.forEach((val) => {
//         document.cookie = val.cookieName+";expires="+val.expires+";domain="+val.domain+";path=/;secure";
//       })
//     }).catch(error => {
//       // Handle error
//       console.log("error===>", error);
//     });

//     console.log("missingCookies==>", missingCookies);
  }

  ngOnInit() {
    // console.log(this.aClickedEvent);
    this.headerService.setCondensedFooterStatus(false);
    this.authenticationService.setLoginSuccessUrl(this.router.routerState.snapshot.url);
    this.pageSlider = this.utilityService.getEnvConfig().homePageCms;
    this.breadCrumbService.removeBreadCrumbs();
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.landingPageRoute = this.authenticationService.getLandingPageRoute();
    if (this.router.url == '/home') {
      this.chips.setChips(undefined);
      this.breadCrumbService.setCurrentBreadCrumb(undefined);
    }
    // const pathname = window.location.pathname;
    // if (pathname.endsWith('/home')) {
    //   this.titleService.setTitle('Manage Your Device Enrollment | AT&T Device Management Program');
    // }
    //code for login error banner
    this.fanInlibleStatus = sessionStorage.getItem('allFansInEligible') ? JSON.parse(sessionStorage.getItem('allFansInEligible')) : false;
    if (this.fanInlibleStatus) {
      this.errorHeader = 'Access Denied';
      this.loginErrorMessage = this.fansInEligibleErrorMsg1 + "\n" + this.fansInEligibleErrorMsg2 + "\n" + this.fansInEligibleErrorMsg3;
    }
    const status = localStorage.getItem('loginFail');
    this.stubIdErrorMsg = sessionStorage.getItem('stubIdError') ? JSON.parse(sessionStorage.getItem('stubIdError'))  : false;
    if (status) {
      localStorage.removeItem('loginFail');
      this.errorHeader = status === '471' || status === '472' || status === '475' || status === '477' ? 'Permission Error' : 'Login Error'; 
      if(this.stubIdErrorMsg) {
        this.loginErrorMessage = (LOGIN_ERROR[status]) ?
        LOGIN_ERROR[status] :
        LOGIN_ERROR['401'];
        sessionStorage.setItem('loginFailedError', 'true');
        // sessionStorage.clear();
        // localStorage.clear();
      } else {
      this.loginErrorMessage = (LOGIN_ERROR[status]) ?
        LOGIN_ERROR[status] :
        LOGIN_ERROR['403'];
        sessionStorage.setItem('loginFailedError', 'true');
      }
      // (document.getElementById('newLogoutBtn') as HTMLButtonElement).click();
    }
    
    this.homeService.getSlider(this.pageSlider)
      .subscribe((respobj) => {
        this.homePage = respobj;
        this.pageCount = respobj.slider.length;
      }, error => {
        this.handleError(error);
      });
    this.homeService.createPageLoadProperties();

    if(ENV_PORTAL === "fnabc" || ENV_PORTAL === "myatt") { 
      this.show5gTile = false;
    }
    //logic for show/hide register menu on 1st time after login
    let noOfFans = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')).user.fanList : 0;
    console.log("noOfFANs===>", JSON.parse(sessionStorage.getItem('user')).user.fanList);
    let fanInfoList = sessionStorage.getItem('fanInfoList') ? JSON.parse(sessionStorage.getItem('fanInfoList')) : [];
    if(noOfFans != 0 && fanInfoList.length > 0) {
      this.authenticationService.updateEnrollStatus({noOfFans: noOfFans.length, fanInfoList: fanInfoList});
    }
    if(!sessionStorage.getItem('loginFailedError')){
      // if (this.isUserLoggedInSuccessfully()) {
        this.getLastLogin();
      // }
    }else{
      sessionStorage.removeItem('loginFailedError')
    }

    if (this.iconsPollSub) {
      this.iconsPollSub.unsubscribe();
    }
    
    this.iconsPollSub = interval(2000)
      .pipe(
        filter(() => {
          const raw = sessionStorage.getItem('accountSummaryData');
          return raw !== null && raw !== undefined;
        }),
        take(1),
        takeUntil(this.destroy$)
      )
      .subscribe(() => {
        this.fanInlibleStatus = sessionStorage.getItem('allFansInEligible') ? JSON.parse(sessionStorage.getItem('allFansInEligible')) : false;
        if(this.fanInlibleStatus){
          this.loginErrorMessage = this.fansInEligibleErrorMsg1 + "\n" + this.fansInEligibleErrorMsg2;
          this.errorHeader = 'Access Denied';
          this.loginErrorMessage = this.fansInEligibleErrorMsg1 + "\n" + this.fansInEligibleErrorMsg2 + "\n" + this.fansInEligibleErrorMsg3;
        }
    });
  }

  ngAfterViewInit(){
    this.dbService.getDb().then(db => {
      this.dbService.clearData('devices').then(() => {
        console.log('Data cleared');
      }).catch(error => {
        console.log('Error clearing data', error);
      });
    });
  }

  ngAfterViewChecked() {
    if (sessionStorage.getItem('iv-user') && this.sendActiveCount === 0) {
      const ivuser = sessionStorage.getItem('iv-user');
      this.sendActiveCount++
      let fanSessionData = {
        sessionID: sessionStorage.getItem('sessionId'),
        fan: "",
      };
      let signupActiveFanList = JSON.parse(sessionStorage.getItem('signupActiveFanList'));
      signupActiveFanList = signupActiveFanList?.filter((item, index) => {
        return signupActiveFanList.indexOf(item) === index;
      });
      // for (let i = 0; i < signupActiveFanList?.length; i++) {
      //   fanSessionData.fan = signupActiveFanList[i];
      //   this.homeService.triggerActiveFans(fanSessionData)
      //     .subscribe((resp) => {
      //     }, error => {
      //       this.handleError(error);
      //     });;
      // }
    }
    if (!this.pageLoadChangesDone && document.getElementById('userProfileInfo')) {
      this.headerService.condensedHeader('home');
      this.pageLoadChangesDone = true;
    }
  }

  getrKey(url) {
    let rkey;
    if (this.firstNetFlag) {
      const loginSuccessUrl = this.authenticationService.getLoginSuccessUrl();
      rkey = loginSuccessUrl ? loginSuccessUrl : 'home';
      window.location.href = url + rkey;
    } else {
      window.location.href = url;
    }
  }
  handleError(error) {
    throw error;
  }

  expandCollapseTiles1(id) {
    if (id === "show") {
      this.openTiles1 = false;
      this.closeTiles1 = true;
      this.hideShortDesc1 = false;
      this.hideLearnMore1 = true;

    } else if (id === "hide") {
      this.openTiles1 = true;
      this.closeTiles1 = false;
      this.hideShortDesc1 = true;
      this.hideLearnMore1 = false;
    }
  }

  expandCollapseTiles2(id) {
    if (id === "show") {
      this.openTiles2 = false;
      this.closeTiles2 = true;
      this.hideShortDesc2 = false;
      this.hideLearnMore2 = true;

    } else if (id === "hide") {
      this.openTiles2 = true;
      this.closeTiles2 = false;
      this.hideShortDesc2 = true;
      this.hideLearnMore2 = false;
    }
  }

  expandCollapseTiles3(id) {
    if (id === "show") {
      this.openTiles3 = false;
      this.closeTiles3 = true;
      this.hideShortDesc3 = false;
      this.hideLearnMore3 = true;

    } else if (id === "hide") {
      this.openTiles3 = true;
      this.closeTiles3 = false;
      this.hideShortDesc3 = true;
      this.hideLearnMore3 = false;

    }
  }

  expandCollapseTiles4(id) {
    if (id === "show") {
      this.openTiles4 = false;
      this.closeTiles4 = true;
      this.hideShortDesc4 = false;
      this.hideLearnMore4 = true;

    } else if (id === "hide") {
      this.openTiles4 = true;
      this.closeTiles4 = false;
      this.hideShortDesc4 = true;
      this.hideLearnMore4 = false;

    }
  }

  checkSlider(buttonLink, title) {
    if (buttonLink.startsWith('http')) {
      this.adobeAnalyticsService.createClickProperties('Learn more about ' + title, 'Body', buttonLink);
      window.open(buttonLink);
    }
    // else {
    //   this.adobeAnalyticsService.createClickProperties('Learn more about ' + title, 'Body', '/businessconsole' + buttonLink);
    //   return this.router.navigate([buttonLink]);
    // }
  }

  navigateDeviceAndShop() {
    let processingFans = JSON.parse(sessionStorage.getItem('processingFanList'));
    let processingFansCount = JSON.parse(sessionStorage.getItem('processingFanList')) ? processingFans.length : 0;
    if (sessionStorage.getItem('sapmp_jwtToken') === null) {
      sessionStorage.setItem('eligibilityCheck', 'true');
      this.landingPageRoute = this.homePage.slider[2].buttonLink;
      console.log("landing page details: " + this.landingPageRoute);
      this.adobeAnalyticsService.createClickProperties(this.homePage.links[0].linkName, 'Body', '/businessconsole' + this.landingPageRoute);
      return this.router.navigate([this.landingPageRoute]);
    }
    this.user = this.authenticationService.getUser();
    if (this.user.addpAuthority !== 'NONE') {
      this.authenticationService.getFanSignedUpStatus()
        .subscribe(resp => {
          sessionStorage.setItem('initialSignupStatus', resp.initialSignupStatus);
          sessionStorage.setItem('noOfDevice', resp.noOfDevices);
          if (resp.fansSummary.length > 0) {
            let signupFanSum = resp.fansSummary;
            let signupFanList = [];
            let signupActiveFanList = [];
            let processingFanList = [];
            let inProgressFan = [];
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "AWAITING_SIGNUP") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('signupFanList', JSON.stringify(signupFanList));

            //get active fans list
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "ACTIVE") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  signupActiveFanList.push(signupFanSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('signupActiveFanList', JSON.stringify(signupActiveFanList));
            //for 'processing' fans
            for (let i = 0; i < signupFanSum.length; i++) {
              if (signupFanSum[i].status == "PROCESSING") {
                for (let j = 0; j < signupFanSum[i].count; j++) {
                  //processingFanList.push(signupFanSum[i].fans[j]);
                  inProgressFan.push(signupFanSum[i].fans[j]);
                  //getting fan info of 'processing' fan to store in session storage
                  for (let k = 0; k < resp.fanInfoList.length; k++) {
                    if (signupFanSum[i].fans[j] === resp.fanInfoList[k].fan) {
                      processingFanList.push(resp.fanInfoList[k]);
                    }
                  }
                }
              }
            }
            sessionStorage.setItem('inProgressFan', JSON.stringify(inProgressFan));
            sessionStorage.setItem('processingFanList', JSON.stringify(processingFanList));
          }
          if (!resp.efotaFansSummary) {
            sessionStorage.setItem('efotaEnrolledFanList', '[]');
          }
          else {
            let efotaFansSum = resp.efotaFansSummary;
            let efotaEnrolledFanList = [];
            for (let i = 0; i < efotaFansSum.length; i++) {
              if (efotaFansSum[i].status == "ACTIVE") {
                for (let j = 0; j < efotaFansSum[i].count; j++) {
                  efotaEnrolledFanList.push(efotaFansSum[i].fans[j]);
                }
              }
            }
            sessionStorage.setItem('efotaEnrolledFanList', JSON.stringify(efotaEnrolledFanList));
          }
          if (!resp.efotaNotEnrolledFanList) {
            sessionStorage.setItem('efotaNotEnrolledFanList', '[]');
            sessionStorage.setItem('efotaEnrollmentInfo', '[]');
          }
          else {
            sessionStorage.setItem('efotaEnrollmentInfo', JSON.stringify(resp.efotaEnrollmentInfo));
            sessionStorage.setItem('efotaNotEnrolledFanList', JSON.stringify(resp.efotaNotEnrolledFanList));
          }

          if (resp.allFansInEligible === true) {
            this.user.fanSignedUpStatus = 'NotEligible';
          } else {
            if (this.user) {
              this.user.fanSignedUpStatus = this.getFanSignedUpStatus(resp.fansSummary);
            }
            if (resp.productCode !== null && resp.productCode !== undefined) {
              this.mdmDetails.productCode = resp.productCode;
              this.mdmDetails.latestAccountType = resp.recentlyEnrolledProduct;
              if (this.mdmDetails.productCode === 'ADDPMDM') {
                this.mdmDetails.ibmEmmAccountId = resp.ibmEmmAccountId;
                let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
                productDetails.emmProductCode = 'ADDPMDM';
                productDetails.selectedAccID = resp.ibmEmmAccountId;
                productDetails.signupEmmStatus = 'revised';
                sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
              } else {
                if (resp.googleEmmAccountId !== null && resp.googleEmmAccountId !== undefined) {
                  this.mdmDetails.googleEmmAccountId = resp.googleEmmAccountId;
                }
                if (resp.samsungEmmAccountId !== null && resp.samsungEmmAccountId !== undefined) {
                  this.mdmDetails.samsungEmmAccountId = resp.samsungEmmAccountId;
                }
                if (resp.fanInfoList !== null && resp.fanInfoList !== undefined) {
                  sessionStorage.setItem('fanInfoList', JSON.stringify(resp.fanInfoList));
                }
              }
              sessionStorage.setItem('mdmDetails', JSON.stringify(this.mdmDetails));
            }
          }
          this.authenticationService.setUser(this.user);

          let checkMore = true;
          let directWelcome = false;
          if (resp.fansSummary) {
            for (let k = 0; k < resp.fansSummary.length; k++) {
              if (resp.fansSummary[k].status === "AWAITING_SIGNUP" && resp.fansSummary[k].count > 0) {
                this.redirectFlag = true;
                checkMore = false;
                if (resp.fansSummary[k].count === resp.noOfFans) {
                  directWelcome = true;
                }
              }
            }
          }

          if (resp.fanInfoList) {
            let fanArr = resp.fanInfoList.map((x) => x.fan);
            let fanArrRefine = [];
            if (fanArr && fanArr.length > 0) {
              fanArrRefine = fanArr.filter(
                (x, index) => fanArr.indexOf(x) === index
              );
            }

            let activeFanArr = resp.fanInfoList.filter((x) => x.accountStatus === "ACTIVE" || x.accountStatus === "SIGNUP_INPROGRESS");
            if (activeFanArr.length === 0) {
              directWelcome = true;
            }

            if (activeFanArr.length < fanArrRefine.length * 3) {
              this.redirectFlag = true;
            }
          }

          if (directWelcome === true) {
            this.router.navigate(['/welcome']);
          } else if (((this.homePage.links[0].rlink === '/learn') && (processingFansCount >= 1)) || this.redirectFlag) {
            this.router.navigate(['/productselection']);
          } else {
            return this.navigationRedirect(this.homePage.links[0].linkName);
          }
        }, () => {
          this.user.fanSignedUpStatus = 'Error';
          this.authenticationService.setUser(this.user);
          return this.navigationRedirect(this.homePage.links[0].linkName);
        });
    } else {
      return this.navigationRedirect(this.homePage.links[0].linkName);
    }
  }

  navigateManage() {
    this.adobeAnalyticsService.createClickProperties(this.homePage.links[1].linkName, 'Body', '/businessconsole/' + this.homePage.links[1].rlink);
  }

  navigateManageInventory() {
    this.adobeAnalyticsService.createClickProperties(this.homePage.links[2].linkName, 'Body', '/businessconsole/' + this.homePage.links[2].rlink);
  }

  navigationRedirect(inputLinkName) {
    const roleFanStaus = this.user.addpAuthority + '_' + this.user.fanSignedUpStatus;
    const redirectInfo = ADDP_PERMISSION_MAPPING[roleFanStaus];

    if (redirectInfo && this.mdmDetails.productCode === 'ADDPMDM' && redirectInfo.logonurl === 'productselection') {
      redirectInfo.logonurl = 'signup';
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    } else if (redirectInfo) {
      this.authenticationService.setLandingPageRoute('/' + redirectInfo.logonurl);
    }
    this.adobeAnalyticsService.createClickProperties(inputLinkName, 'Body', '/businessconsole' + this.landingPageRoute);
    this.landingPageRoute = this.authenticationService.getLandingPageRoute();
    this.router.navigate([this.landingPageRoute]);
  }

  getFanSignedUpStatus(fansSummary) {
    let fanSignedUpStatus = 'NONE';
    if (fansSummary) {
      const signedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'ACTIVE' || f.status === 'READY_TO_SETUP'; }).length;
      const notSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'AWAITING_SIGNUP'; }).length;
      const abmfePendingSignedUpFansCount = fansSummary.
        filter((f) => { return f.status === 'PROCESSING' || f.status === 'SIGNUP_INPROGRESS' }).length;
      if (abmfePendingSignedUpFansCount > 0) {
        fanSignedUpStatus = 'PROCESSING';
      }
      if (signedUpFansCount > 0 && notSignedUpFansCount > 0) {
        fanSignedUpStatus = 'SOME';
      } else if (signedUpFansCount > 0 && notSignedUpFansCount === 0) {
        fanSignedUpStatus = 'ALL';
      } else {
        fanSignedUpStatus = 'NONE';
      }
    }
    return fanSignedUpStatus;
  }

  handleLoginError() {
    /** need to handle error scenarios */
    this.pageloaderService.setPageLoaderStatus(true);
    this.router.navigate(['errorPage', 'loginFailure']);
  };

  closeOverviewModal(){
    this.showProfileErrorModal = false;
  }

  getLastLogin(){
    if (!sessionStorage.getItem('loginFailedError')) {
      const currentSessionId = sessionStorage.getItem('sessionId') || '';
      const historySessionId = sessionStorage.getItem('lastLoginHistorySessionId') || '';
      const hasCachedHistory = !!sessionStorage.getItem('lastLoginHistory');

      if (hasCachedHistory && currentSessionId && currentSessionId === historySessionId) {
        this.showLastLogin();
        return;
      }

      this.authenticationService.getLastLoginHistory().subscribe(
        (loginRes) => {
          console.log("last login info: ", loginRes);
          sessionStorage.setItem('lastLoginHistory', JSON.stringify(loginRes));
          sessionStorage.setItem('lastLoginHistorySessionId', currentSessionId);
          this.showLastLogin();
        },
        (error) => {
          console.error('Error fetching last login history:', error);
        }
      ); 
    }else{
      sessionStorage.removeItem('loginFailedError')
    }
  }

  showLastLogin(){
    let lastLogin = sessionStorage.getItem('lastLoginHistory') ? JSON.parse(sessionStorage.getItem('lastLoginHistory')) : '';
    if(lastLogin.lastLoggedInTime != null){
      console.log("Last LOgin: ", lastLogin);
      let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      console.log("localTimeZone: ", localTimeZone);
      let queryString = lastLogin.lastLoggedInTime.replace(/-/g, '/');
     // let dateN = new Date(lastLogin.lastLoggedInTime);
      //let newDt = (dateN.getMonth()+1)+"/"+dateN.getDate() +"/"+ dateN.getFullYear() +" "+ dateN.getHours()+":"+dateN.getMinutes()+":"+dateN.getSeconds();
      //console.log("date format: ", newDt);
      const now = new Date(queryString + " UTC");
      const formattedDate = now.toLocaleString('en-US', {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: true,
          timeZone: localTimeZone
      });
      this.lastLoginTime = sessionStorage.setItem('lastLoginTime', formattedDate);
      console.log("formattedDate: ", formattedDate);//check Invalid Date
      document.getElementsByClassName("last-login-info")[0].innerHTML = formattedDate != "Invalid Date" ? "Last Login: "+ formattedDate : "";
      document.getElementsByClassName("last-login-info")[1].innerHTML = formattedDate != "Invalid Date" ? "Last Login: "+ formattedDate : "";
    }
  }

  nOnDestroy() {
    if (this.iconsPollSub) {
      this.iconsPollSub.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }

}
